export interface Post {
  id: number;
  slug: string;
  title: string;
  category: string;
  tag: string;
  summary: string;
  cover: string;
  author: string;
  date: string;
  views: string;
  minutes: number;
  hot: number;
  featured?: boolean;
  content: string[];
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const SITE = {
  name: "九一吃瓜",
  slogan: "新瓜速递 · 热门事件前排围观现场",
  desc: "一手现场图文直击，满足你第一时间吃瓜的好奇心。",
  email: "hi@91chigua.example",
};

export const CATEGORIES: Category[] = [
  { id: "yule", name: "娱乐现场", icon: "ri-flashlight-line", desc: "热门事件前排围观，一手画面速览" },
  { id: "zongyi", name: "综艺热点", icon: "ri-vidicon-line", desc: "热播综艺名场面与热搜话题整理" },
  { id: "juying", name: "剧集热议", icon: "ri-clapperboard-line", desc: "热播剧集剧情看点与观众讨论" },
  { id: "shidian", name: "社会视点", icon: "ri-earth-line", desc: "大众关注的新闻事件一线梳理" },
  { id: "leju", name: "乐坛趣闻", icon: "ri-music-2-line", desc: "音乐现场与歌手动态速递" },
  { id: "rehuan", name: "新鲜热梗", icon: "ri-chat-smile-line", desc: "全网流行的网络热梗与话题盘点" },
];

export const POSTS: Post[] = [
  {
    id: 1,
    slug: "summer-concert-front-row",
    title: "夏夜音乐节现场前排直击：万人合唱名场面刷屏",
    category: "乐坛趣闻",
    tag: "现场速递",
    summary: "周末音乐节收官夜，压轴歌手登台即全场沸腾，万人合唱把夜空唱成了银河。现场前排观众拍下的画面迅速占领热搜。",
    cover: "https://readdy.ai/api/search-image?query=concert%20crowd%20silhouette%20holding%20phone%20lights%20up%20against%20warm%20orange%20sunset%20sky%20with%20festival%20stage%20lights%20glowing%20in%20background%2C%20joyful%20live%20music%20atmosphere%2C%20editorial%20photography%2C%20rich%20warm%20amber%20and%20coral%20tones%2C%20high%20detail&width=800&height=1000&seq=gossip-concert-01&orientation=portrait",
    author: "前排拍客",
    date: "09-06 20:40",
    views: "126.8w",
    minutes: 6,
    hot: 99,
    featured: true,
    content: [
      "收官夜的现场氛围从傍晚就一路升温。安检入口排队的人群一路绵延到路口，不少人是专程从外地赶来赴这场夏日之约，手上还拿着未拆封的应援灯牌。",
      "晚八点开场后，前两小时的暖场乐队把气氛一点点点燃。真正的高潮出现在压轴歌手登台的一刻——暗下的灯光忽然亮起，全场数万人同时亮起手机灯，画面从观众席蔓延到看台，像一条流动的光河。",
      "第一首副歌响起时，全场已经不需要领唱，万人自发合唱的声音把伴奏都盖了过去。台下的前排观众举着手机，镜头里是无数张亮着光的脸，有人笑着唱，有人红了眼眶。",
      "散场后的社交平台几乎被同一段视频刷屏：绚烂的烟花在夜空中炸开，万人合唱的声浪扑面而来。不少没到现场的人留言表示，隔着屏幕也被这份热情打动。",
      "今年夏天像这样的音乐现场还有很多。对热爱现场的人来说，音乐节不只是听歌，更是一次难得的集体记忆——在盛夏的晚风里，和陌生人一起唱出同一首歌。",
    ],
  },
  {
    id: 2,
    slug: "variety-show-mentor-highlight",
    title: "新一季竞演综艺开播即爆：导师金句与选手泪点齐飞",
    category: "综艺热点",
    tag: "热播综艺",
    summary: "竞演综艺迎来首播，导师点评金句频出，选手舞台背后的故事赚足眼泪，开播首期就登上多个热搜话题。",
    cover: "https://readdy.ai/api/search-image?query=bright%20studio%20stage%20with%20colorful%20spotlights%20and%20silhouettes%20of%20performers%20on%20stage%2C%20modern%20television%20variety%20show%20set%2C%20warm%20amber%20and%20coral%20stage%20lighting%20with%20teal%20accents%2C%20dynamic%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=gossip-variety-01&orientation=landscape",
    author: "节目观察员",
    date: "09-06 19:10",
    views: "89.3w",
    minutes: 7,
    hot: 96,
    content: [
      "停播一年后回归的这档竞演综艺，首播就用扎实的内容交出了高分答卷。从舞美到赛制都做了升级，选手阵容更是话题度拉满。",
      "首期最大的惊喜来自导师席。几位导师的点评一改往季的温和客套，直言不讳又句句在理，一段关于'技巧与情感谁更重要'的讨论被网友反复转发，成为当晚最大的金句来源。",
      "舞台之外，选手的幕后故事同样打动人心。一位练习多年的选手首度讲述自己数次与舞台失之交臂的经历，说到动情处台下导师也红了眼眶，弹幕刷满了鼓励。",
      "从弹幕和热搜的双重反馈来看，观众对'真实感'的渴望远超想象。当节目愿意放下剧本、呈现真实的人与真挚的表达，观众自然会用热度回应。",
    ],
  },
  {
    id: 3,
    slug: "drama-viral-clip",
    title: "年度黑马剧再添名场面：单条台词片段播放量破亿",
    category: "剧集热议",
    tag: "热播剧集",
    summary: "一部不被看好的都市剧靠口碑逆袭，剧中一段关于'平凡生活'的独白被疯狂剪辑传播，播放量轻松破亿。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cozy%20urban%20night%20scene%20of%20a%20young%20person%20standing%20by%20warm%20window%20light%20looking%20at%20city%20lights%2C%20melancholic%20yet%20hopeful%20mood%2C%20film%20still%20aesthetic%2C%20warm%20amber%20and%20soft%20coral%20tones%2C%20shallow%20depth%20of%20field%20editorial%20photography&width=800&height=600&seq=gossip-drama-01&orientation=landscape",
    author: "追剧小站",
    date: "09-06 17:55",
    views: "203.1w",
    minutes: 5,
    hot: 98,
    content: [
      "开播前几乎没人看好的这部都市剧，如今成了当之无愧的口碑黑马。没有顶流演员、没有宏大场面，靠的是一段段贴近生活的小人物故事。",
      "真正让它出圈的是剧中一段近三分钟的独白。主角在深夜加班后独自坐在天台上，对着一座灯火通明的城市，平静地说起'平凡不是失败，是大多数人的生活底色'。",
      "这段台词在社交平台被反复剪辑，配乐版、手写版、翻拍版层出不穷，累计播放量在数日内突破一亿。无数网友在评论区写下自己被戳中的瞬间。",
      "业内人士分析，这部剧的成功印证了一个朴素的道理：当内容足够真诚、足够贴近真实生活，观众就愿意为它停留。流量时代，稀缺的从来不是热闹，而是共鸣。",
    ],
  },
  {
    id: 4,
    slug: "rescue-dog-warm-story",
    title: "一座小城为流浪犬建起暖心驿站，志愿者故事看哭全网",
    category: "社会视点",
    tag: "暖心正片",
    summary: "某县城一群普通志愿者自费建起流浪动物救助站，风雨无阻照顾数百只小狗，他们的故事在网络上引发刷屏式点赞。",
    cover: "https://readdy.ai/api/search-image?query=soft%20heartwarming%20scene%20of%20a%20small%20dog%20being%20gently%20held%20in%20cupped%20hands%20with%20warm%20afternoon%20sunlight%2C%20tender%20rescue%20shelter%20atmosphere%2C%20warm%20cream%20and%20amber%20tones%2C%20compassionate%20editorial%20photography%2C%20gentle%20bokeh%20background&width=800&height=600&seq=gossip-social-01&orientation=landscape",
    author: "一线小编",
    date: "09-06 16:30",
    views: "77.5w",
    minutes: 8,
    hot: 91,
    featured: true,
    content: [
      "在西南一座并不起眼的小县城，有一群普通的年轻人，用五年时间为一群流浪犬建起了一个可以遮风挡雨的家。",
      "救助站最早的发起人是一名宠物医生。最初只是在接诊时顺手收留几只被遗弃的小狗，后来收养的越来越多，便和几位朋友一起租下城郊一片空地，搭起了简易棚舍。",
      "如今这里住着三百多只小狗。志愿者们白天上班、晚上赶来喂食打扫，节假日更是全员上阵。为了节省开支，他们学会了给小狗做简单的护理，甚至自己动手修缮笼舍。",
      "他们的故事被网友偶然拍下并发到网上，短短几天就获得百万点赞。评论区里，有人问如何捐款捐物，也有人被这份朴素的坚持打动，决定加入当地的志愿队伍。",
      "救助站负责人说，他们最需要的其实不是一次性关注，而是更多人养成不遗弃宠物的意识。愿每一只小狗都能被温柔以待。",
    ],
  },
  {
    id: 5,
    slug: "viral-craft-paper-cut",
    title: "95后手艺人让剪纸'开口说话'：非遗作品走红海外",
    category: "新鲜热梗",
    tag: "国潮出圈",
    summary: "一位95后剪纸手艺人在短视频平台用一把剪刀'剪'出会动的故事，融合动画与传统技艺的作品在海外平台广受欢迎。",
    cover: "https://readdy.ai/api/search-image?query=intricate%20chinese%20red%20paper%20cutting%20artwork%20held%20by%20hands%20against%20soft%20cream%20background%2C%20delicate%20folk%20art%20craft%20detail%2C%20warm%20red%20and%20cream%20tones%2C%20macro%20editorial%20photography%20celebrating%20cultural%20heritage&width=800&height=600&seq=gossip-craft-01&orientation=landscape",
    author: "文化编辑部",
    date: "09-06 14:05",
    views: "52.9w",
    minutes: 4,
    hot: 88,
    content: [
      "传统剪纸在大多数人印象里是贴在窗上的静态年味，但在一位95后手艺人的手里，它变成了会讲故事的存在。",
      "这位手艺人在大学里学的是动画设计，毕业后却一头扎进传统剪纸里。她把剪纸与逐帧动画结合起来，让一张张红纸上的小人和小动物真的'动'了起来。",
      "她的作品在短视频平台发布后迅速走红，点赞最高的是一条讲述农历新年的剪纸动画，古朴的造型搭配灵动的动作，被网友评价为'会呼吸的传统文化'。",
      "让人意外的是，这些作品在海外社交平台同样广受欢迎。不少外国网友在评论区留言，称赞这是'最浪漫的中国手工艺'，还有人留言询问能否买到同款课程。",
      "面对走红，她显得很平静：'剪纸本身就很美，我只是用年轻人能接受的方式，让它被更多人看见。'用新技术讲好老故事，或许正是国潮最好的模样。",
    ],
  },
  {
    id: 6,
    slug: "night-market-foodie",
    title: "深夜觅食指南：老城夜市人气摊位地图实测",
    category: "社会视点",
    tag: "探店实测",
    summary: "我们花了一整夜实测老城夜市人气摊位，从本地人私藏的凉皮到排队一小时的烤串，整理出一份不踩雷的觅食地图。",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20asian%20night%20market%20food%20stall%20glowing%20with%20warm%20string%20lights%2C%20steaming%20street%20food%20being%20served%2C%20lively%20crowd%20atmosphere%2C%20rich%20warm%20amber%20orange%20and%20red%20tones%2C%20appetizing%20editorial%20food%20photography%20high%20detail&width=800&height=1000&seq=gossip-night-01&orientation=portrait",
    author: "觅食小分队",
    date: "09-06 12:20",
    views: "64.2w",
    minutes: 9,
    hot: 93,
    content: [
      "深夜十点，城市渐渐安静，老城夜市却刚刚热闹起来。蒸腾的热气、此起彼伏的吆喝，交织成属于夜晚的烟火气。",
      "第一站是本地人私藏的凉皮摊。老板在这条街摆了十五年摊，凉皮现切现拌，酱汁是自家秘方，酸辣爽口，一碗下肚解腻又开胃。",
      "第二站是排队一小时的网红烤串。炭火炙烤下的肉串滋滋冒油，撒上一把辣椒孜然，焦香扑鼻。实测下来，等待虽久，味道确实值回票价。",
      "夜市最迷人的，除了美食还有人情味。摊主们大多在这条街守了很多年，记得常客的口味，会多给一把葱花，也会在你纠结时笑着推荐招牌。",
      "深夜的城市，用一碗热气腾腾的食物抚慰每一个晚归的人。这份实测地图，献给同样热爱夜市的你——记得空着肚子来。",
    ],
  },
  {
    id: 7,
    slug: "e-sports-championship",
    title: "电竞总决赛巅峰对决：逆风翻盘瞬间全网沸腾",
    category: "娱乐现场",
    tag: "赛事热点",
    summary: "电竞夏季总决赛上演史诗级翻盘，决胜局最后五分钟局势三度反转，夺冠瞬间线下场馆与线上弹幕同时沸腾。",
    cover: "https://readdy.ai/api/search-image?query=high%20energy%20esports%20arena%20with%20large%20glowing%20screen%20and%20cheering%20crowd%20silhouettes%2C%20dramatic%20red%20and%20orange%20spotlights%20over%20stage%2C%20intense%20competitive%20gaming%20atmosphere%2C%20editorial%20event%20photography%2C%20vivid%20warm%20tones&width=800&height=600&seq=gossip-esport-01&orientation=landscape",
    author: "比赛直击",
    date: "09-06 11:00",
    views: "168.4w",
    minutes: 6,
    hot: 97,
    content: [
      "这场电竞夏季总决赛，被无数观众称为'今年最精彩的一场比赛'。两支队伍从小组赛一路杀入决赛，实力相当，让胜负悬念保持到了最后一刻。",
      "前四局双方你来我往打成平手，决胜局的战况却一波三折。落后一方的队伍在经济大幅落后的劣势下，依靠一次教科书般的团战成功翻盘，把比赛拖入最紧张的白热阶段。",
      "最后的五分钟里，局势三度反转。每一次团战结束，线下场馆都会爆发出整片惊呼，线上弹幕更是以肉眼难以分辨的速度滚动。",
      "当水晶被推掉的那一刻，夺冠队员们抱作一团，看台上彩带纷飞，场馆内的欢呼几乎掀翻屋顶。镜头扫过观众席，不少老玩家激动得热泪盈眶。",
      "竞技体育的魅力，正在于永不言弃。无论结果如何，这支队伍在逆境中展现出的韧性，都值得所有人起立鼓掌。",
    ],
  },
  {
    id: 8,
    slug: "traffic-police-melody",
    title: "暴雨中交警抱出被困司机，暖心画面获全网点赞",
    category: "社会视点",
    tag: "暖心正片",
    summary: "一场突如其来的暴雨让城区多处路段积水，一名交警蹚着齐腰深的积水抱出被困司机，画面被行车记录仪拍下后刷屏。",
    cover: "https://readdy.ai/api/search-image?query=heavy%20rainstorm%20scene%20of%20a%20uniformed%20rescuer%20walking%20through%20deep%20flooded%20street%20water%20at%20dusk%20carrying%20someone%2C%20dramatic%20weather%2C%20cinematic%20teal%20and%20amber%20tones%2C%20respectful%20editorial%20news%20photography%20conveying%20bravery%20and%20warmth&width=800&height=600&seq=gossip-police-01&orientation=landscape",
    author: "一线小编",
    date: "09-06 09:15",
    views: "45.6w",
    minutes: 5,
    hot: 90,
    content: [
      "前几日一场突如其来的暴雨，让许多城市的早高峰变得格外艰难。城区多段道路积水严重，不少车辆在低洼路段被困。",
      "一段行车记录仪拍下的画面，却让无数人在雨天里感受到了温暖。画面中，一名交警蹚着齐腰深的积水艰难前行，在确认一辆抛锚车内有司机被困后，二话不说将其背起，一步步送到安全地带。",
      "视频被发布到网上后迅速刷屏，短短数小时点赞突破百万。评论区里，无数网友向这位交警和所有坚守岗位的人致敬。",
      "事后采访中，这位年轻的交警有些不好意思地表示，这只是本职工作：'那天雨确实很大，但看到有人需要帮助，来不及想那么多。'",
      "恶劣天气面前，正是无数像他一样默默付出的普通人，撑起了这座城市的安全感。向每一位风雨中的守护者致敬。",
    ],
  },
  {
    id: 9,
    slug: "home-studio-renovation",
    title: "年轻人开始爆改老房子：低成本改造清单全网疯传",
    category: "新鲜热梗",
    tag: "生活方式",
    summary: "租房和改造成为当下年轻人的生活新乐趣，一份百元级低成本改造清单走红，让破旧小房间焕然一新。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20modern%20minimalist%20small%20bedroom%20interior%20being%20renovated%20with%20warm%20afternoon%20light%2C%20clean%20bright%20walls%20and%20soft%20neutral%20textiles%20with%20warm%20coral%20accent%20chair%2C%20hygge%20lifestyle%20editorial%20photography%2C%20inviting%20warm%20tones%20high%20detail&width=800&height=1000&seq=gossip-room-01&orientation=portrait",
    author: "生活实验室",
    date: "09-05 21:40",
    views: "38.7w",
    minutes: 7,
    hot: 86,
    content: [
      "如今越来越多的年轻人开始认真对待'住'这件事。与其抱怨房子老旧，不如动手把它改造成自己喜欢的样子，成为许多人的生活态度。",
      "走红网络的这份低成本改造清单，是一位博主在改造自己租住的三十平米老房后总结的。从换一盏温暖的落地灯，到铺一块柔软的地毯，再到用挂画和绿植点亮墙面，整套改造下来花费不到一千元。",
      "清单最打动人的地方，在于它把'改造'这件事变得简单可行。没有大动干戈的装修，而是通过灯光、软装和收纳这些细节，让空间气质焕然一新。",
      "评论区里，不少网友晒出自己的改造前后对比照。有人把灰扑扑的阳台变成了小花园，有人用布帘隔出了舒适的阅读角，每一处用心都让生活多了一分温度。",
      "房子可以是租来的，但生活不是。在能力范围内把日子过成喜欢的样子，这份对生活的热情，本身就值得点赞。",
    ],
  },
];

export const HOT_RANK = POSTS.map((p) => p).sort((a, b) => b.hot - a.hot);

export const FAQS: { q: string; a: string }[] = [
  {
    q: "九一吃瓜的内容多久更新一次？",
    a: "九一吃瓜的小编会分时段滚动更新，早中晚都会补充新瓜速递，遇到重大热门事件时还会开启前排围观现场、实时跟进最新画面与进展。",
  },
  {
    q: "如何确保看到的瓜是真实可信的？",
    a: "我们坚持一手现场优先，尽量引用可核实的公开画面与多方信源，并对存疑信息加以标注。也欢迎用户在站内留言补充或纠正，共同维护可信的围观氛围。",
  },
  {
    q: "想投稿或分享自己拍到的新瓜，怎么联系？",
    a: "欢迎通过站内联系表单或官方邮箱投稿。请确保提供的信息真实可核实，并附上尽可能完整的时间、地点与原始画面，审核通过后我们会第一时间安排发布。",
  },
  {
    q: "吃瓜时需要注意哪些分寸？",
    a: "围观也要有边界。我们倡导理性吃瓜，尊重当事人的隐私与合法权益，不传播未经证实的恶意揣测，更不做网暴的助推者。友善围观，才能让热点保持温度。",
  },
  {
    q: "会不会插入很多广告影响阅读？",
    a: "九一吃瓜以内容体验为先，我们会克制广告密度，确保不打扰正常的速递阅读与现场围观，让每一次点开都有收获。",
  },
];